import { MichelinLogo } from "../../logos/MichelinLogo";
export var getLogoMichelin = function getLogoMichelin() {
  return {
    primary: MichelinLogo.DEFAULT
  };
};